var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('paymentInformation.INVOICE_NOTICE'))+" ")]),_c('v-form',{ref:"form"},[_c('AddressPicker',{ref:"check-wire-address-picker",staticClass:"margin-t-4",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }